import { useQuery } from '@tanstack/react-query';
import { useApiClient } from './useApiClient';

export interface FlowDataPoint {
  datetime: string;
  rate: number | null;
}

interface MeterFlowResponse {
  flow: FlowDataPoint[];
}

export function useMeterFlow(
  sensorId: string | undefined,
  dateRange?: { from: Date; to: Date },
) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['meter-flow', sensorId, dateRange?.from, dateRange?.to],
    queryFn: () => {
      const params = dateRange
        ? `?start=${dateRange.from.toISOString()}&end=${dateRange.to.toISOString()}`
        : '';
      return apiClient.get<MeterFlowResponse>(`meters/${sensorId}/flow${params}`);
    },
    enabled: !!sensorId,
  });
}
